import { Typography } from "@mui/material";

export function SubmissionInfoTooltip({
  title,
  message,
}: {
  title: string;
  message: string;
}) {
  return (
    <>
      <Typography variant="body2" fontWeight="bold">
        {title}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        {message}
      </Typography>
    </>
  );
}

export function CreateSubmissionInfoTooltip() {
  return (
    <SubmissionInfoTooltip
      title="Create Submission"
      message="Enter information about the submission. After all data has been entered, you can send immediately to reviewers or save to send to reviewers later."
    />
  );
}

export function EditSubmissionInfoTooltip() {
  return (
    <SubmissionInfoTooltip
      title="Edit Submission"
      message="Enter information about the submission. After all data has been entered, you can send immediately to reviewers or save to send to reviewers later."
    />
  );
}

export function PriorityOrderInfoTooltip() {
  return (
    <SubmissionInfoTooltip
      title="Priority order for reviews"
      message="Check this option if this submission needs reviews to be completed in a specific order. Reviewers will not receive a notification that this submission is ready for review until the previous reviewer has completed their review."
    />
  );
}
